import React, { useState } from "react";
import {
  Box,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Card,
  CardContent,
  Grid,
  InputAdornment,
  Chip,
  Tooltip,
  Alert,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Avatar,
  Badge,
  Switch,
  FormControlLabel,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Collapse,
} from "@mui/material";
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  Search as SearchIcon,
  Add as AddIcon,
  Category as CategoryIcon,
  Info as InfoIcon,
  Refresh as RefreshIcon,
  Visibility as ViewIcon,
  AccountTree as TreeIcon,
  FolderOpen as FolderIcon,
  Folder as FolderClosedIcon,
  SubdirectoryArrowRight as SubCategoryIcon,
  LocalOffer as TagIcon,
  ExpandLess as ExpandLessIcon,
  ExpandMore as ExpandMoreIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  Apps as AppsIcon,
} from "@mui/icons-material";
import AlertModal from "../../../components/AlertModal";
import ConfirmModal from "../../../components/ConfirmModal";


const CategoryMaster = () => {
  const [categoryData, setCategoryData] = useState([
    {
      id: 1,
      categoryCode: "CAT001",
      categoryName: "Electronics",
      parentCategory: null,
      level: "Main Category",
      description: "Electronic items and gadgets",
      productCount: 45,
      status: "Active",
      displayOrder: 1,
      showOnWebsite: true,
      createdDate: "2024-01-15",
      updatedDate: "2024-01-15"
    },
    {
      id: 2,
      categoryCode: "CAT002",
      categoryName: "Computers",
      parentCategory: "Electronics",
      level: "Sub Category",
      description: "Desktop computers, laptops, and accessories",
      productCount: 25,
      status: "Active",
      displayOrder: 1,
      showOnWebsite: true,
      createdDate: "2024-01-15",
      updatedDate: "2024-01-15"
    },
    {
      id: 3,
      categoryCode: "CAT003",
      categoryName: "Mobile Devices",
      parentCategory: "Electronics",
      level: "Sub Category",
      description: "Smartphones, tablets, and wearables",
      productCount: 20,
      status: "Active",
      displayOrder: 2,
      showOnWebsite: true,
      createdDate: "2024-01-15",
      updatedDate: "2024-01-15"
    },
    {
      id: 4,
      categoryCode: "CAT004",
      categoryName: "Furniture",
      parentCategory: null,
      level: "Main Category",
      description: "Office and home furniture",
      productCount: 30,
      status: "Active",
      displayOrder: 2,
      showOnWebsite: true,
      createdDate: "2024-01-15",
      updatedDate: "2024-01-15"
    },
    {
      id: 5,
      categoryCode: "CAT005",
      categoryName: "Office Furniture",
      parentCategory: "Furniture",
      level: "Sub Category",
      description: "Desks, chairs, and storage solutions",
      productCount: 18,
      status: "Active",
      displayOrder: 1,
      showOnWebsite: true,
      createdDate: "2024-01-15",
      updatedDate: "2024-01-15"
    },
    {
      id: 6,
      categoryCode: "CAT006",
      categoryName: "Home Furniture",
      parentCategory: "Furniture",
      level: "Sub Category",
      description: "Living room and bedroom furniture",
      productCount: 12,
      status: "Active",
      displayOrder: 2,
      showOnWebsite: true,
      createdDate: "2024-01-15",
      updatedDate: "2024-01-15"
    },
    {
      id: 7,
      categoryCode: "CAT007",
      categoryName: "Stationery",
      parentCategory: null,
      level: "Main Category",
      description: "Office supplies and stationery items",
      productCount: 50,
      status: "Active",
      displayOrder: 3,
      showOnWebsite: true,
      createdDate: "2024-01-15",
      updatedDate: "2024-01-15"
    },
    {
      id: 8,
      categoryCode: "CAT008",
      categoryName: "Writing Instruments",
      parentCategory: "Stationery",
      level: "Sub Category",
      description: "Pens, pencils, and markers",
      productCount: 35,
      status: "Active",
      displayOrder: 1,
      showOnWebsite: true,
      createdDate: "2024-01-15",
      updatedDate: "2024-01-15"
    },
    {
      id: 9,
      categoryCode: "CAT009",
      categoryName: "Paper Products",
      parentCategory: "Stationery",
      level: "Sub Category",
      description: "Notebooks, papers, and files",
      productCount: 15,
      status: "Active",
      displayOrder: 2,
      showOnWebsite: true,
      createdDate: "2024-01-15",
      updatedDate: "2024-01-15"
    },
    {
      id: 10,
      categoryCode: "CAT010",
      categoryName: "Accessories",
      parentCategory: "Electronics",
      level: "Sub Category",
      description: "Electronic accessories and peripherals",
      productCount: 0,
      status: "Inactive",
      displayOrder: 3,
      showOnWebsite: false,
      createdDate: "2024-01-15",
      updatedDate: "2024-01-15"
    },
  ]);

  const [searchQuery, setSearchQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [levelFilter, setLevelFilter] = useState("all");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [successMessage, setSuccessMessage] = useState("");
  const [errors, setErrors] = useState({});
  const [viewMode, setViewMode] = useState("table"); // "table" or "tree"

  // Modal state
  const [openModal, setOpenModal] = useState(false);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [editingCategory, setEditingCategory] = useState(null);
  const [viewingCategory, setViewingCategory] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  // Modal states
  const [alertConfig, setAlertConfig] = useState({ open: false, title: 'Alert', message: '', type: 'info' });
  const [confirmConfig, setConfirmConfig] = useState({ open: false, title: 'Confirm', message: '', onConfirm: null });

  const showAlert = (message, type = 'info', title = 'Alert') => {
    setAlertConfig({ open: true, title, message, type });
  };

  const showConfirm = (message, onConfirm, title = 'Confirm') => {
    setConfirmConfig({ open: true, title, message, onConfirm });
  };

  const [newCategory, setNewCategory] = useState({
    categoryCode: "",
    categoryName: "",
    parentCategory: "",
    level: "Main Category",
    description: "",
    status: "Active",
    displayOrder: 1,
    showOnWebsite: true,
  });

  // Tree view state
  const [expandedCategories, setExpandedCategories] = useState({});

  // Get main categories for parent dropdown
  const mainCategories = categoryData.filter(cat => cat.level === "Main Category");

  // Helper functions
  const getFilteredCategories = () => {
    return categoryData.filter((category) => {
      const matchesSearch = Object.values(category).some((value) =>
        String(value).toLowerCase().includes(searchQuery.toLowerCase())
      );
      const matchesStatus = statusFilter === "all" || category.status === statusFilter;
      const matchesLevel = levelFilter === "all" || category.level === levelFilter;
      return matchesSearch && matchesStatus && matchesLevel;
    });
  };

  const getStatusStyle = (status) => {
    switch (status) {
      case 'Active':
        return { backgroundColor: '#e8f5e9', color: '#2e7d32' };
      case 'Inactive':
        return { backgroundColor: '#ffebee', color: '#d32f2f' };
      default:
        return { backgroundColor: '#f5f5f5', color: '#666' };
    }
  };

  const getLevelColor = (level) => {
    switch (level) {
      case 'Main Category':
        return 'primary';
      case 'Sub Category':
        return 'secondary';
      default:
        return 'default';
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!newCategory.categoryCode.trim()) newErrors.categoryCode = 'Category code is required';
    if (!newCategory.categoryName.trim()) newErrors.categoryName = 'Category name is required';
    if (newCategory.level === "Sub Category" && !newCategory.parentCategory) {
      newErrors.parentCategory = 'Parent category is required for sub categories';
    }
    if (!newCategory.displayOrder || newCategory.displayOrder <= 0) {
      newErrors.displayOrder = 'Display order must be greater than 0';
    }
    return newErrors;
  };

  // Handlers
  const handleEdit = (category) => {
    setEditingCategory(category);
    setNewCategory({ ...category });
    setOpenModal(true);
  };

  const handleView = (category) => {
    setViewingCategory(category);
    setOpenViewModal(true);
  };

  const handleDelete = (id) => {
    const categoryToDelete = categoryData.find(cat => cat.id === id);

    // Check if category has subcategories
    const hasSubCategories = categoryData.some(cat => cat.parentCategory === categoryToDelete.categoryName);

    if (hasSubCategories) {
      showAlert("Cannot delete category with subcategories. Please delete or reassign subcategories first.", "error", "Cannot Delete");
      return;
    }

    showConfirm("Are you sure you want to delete this category?", () => {
      setCategoryData(categoryData.filter((category) => category.id !== id));
      setSuccessMessage("Category deleted successfully!");
      setTimeout(() => setSuccessMessage(""), 3000);
    });
  };


  const handleChangePage = (_, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Search and filter handlers
  const handleSearch = () => {
    setPage(0);
    setSuccessMessage(`Search completed. Found ${getFilteredCategories().length} categories.`);
    setTimeout(() => setSuccessMessage(""), 3000);
  };

  const handleReset = () => {
    setSearchQuery("");
    setStatusFilter("all");
    setLevelFilter("all");
    setPage(0);
    setErrors({});
    setSuccessMessage("");
  };

  const handleOpenModal = () => {
    setEditingCategory(null);
    setNewCategory({
      categoryCode: "",
      categoryName: "",
      parentCategory: "",
      level: "Main Category",
      description: "",
      status: "Active",
      displayOrder: 1,
      showOnWebsite: true,
    });
    setErrors({});
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setEditingCategory(null);
    setErrors({});
  };

  const handleCloseViewModal = () => {
    setOpenViewModal(false);
    setViewingCategory(null);
  };

  const handleInputChange = (e) => {
    const { name, value, checked, type } = e.target;
    setNewCategory({
      ...newCategory,
      [name]: type === 'checkbox' ? checked : value
    });
    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
  };

  const handleAddCategory = async () => {
    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }

    setIsLoading(true);
    try {
      if (editingCategory) {
        // Update existing category
        setCategoryData(categoryData.map(category =>
          category.id === editingCategory.id
            ? {
              ...category,
              ...newCategory,
              updatedDate: new Date().toISOString().split('T')[0]
            }
            : category
        ));
        setSuccessMessage("Category updated successfully!");
      } else {
        // Add new category
        const newId = categoryData.length > 0 ? Math.max(...categoryData.map(c => c.id)) + 1 : 1;
        const categoryCode = `CAT${String(newId).padStart(3, '0')}`;
        setCategoryData([...categoryData, {
          id: newId,
          ...newCategory,
          categoryCode: newCategory.categoryCode || categoryCode,
          productCount: 0,
          createdDate: new Date().toISOString().split('T')[0],
          updatedDate: new Date().toISOString().split('T')[0]
        }]);
        setSuccessMessage("Category added successfully!");
      }
      handleCloseModal();
    } catch (error) {
      setErrors({ general: "An error occurred. Please try again." });
    } finally {
      setIsLoading(false);
      setTimeout(() => setSuccessMessage(""), 3000);
    }
  };

  const filteredCategories = getFilteredCategories();

  // Calculate statistics
  const totalCategories = categoryData.length;
  const mainCategoriesCount = categoryData.filter(c => c.level === "Main Category").length;
  const subCategoriesCount = categoryData.filter(c => c.level === "Sub Category").length;
  const activeCategories = categoryData.filter(c => c.status === "Active").length;
  const totalProducts = categoryData.reduce((sum, category) => sum + category.productCount, 0);

  // Toggle tree expand/collapse
  const handleToggleExpand = (categoryName) => {
    setExpandedCategories({
      ...expandedCategories,
      [categoryName]: !expandedCategories[categoryName]
    });
  };

  // Render tree view
  const renderTreeView = () => {
    const mainCats = filteredCategories.filter(cat => cat.level === "Main Category");

    return (
      <Paper sx={{ borderRadius: 2, boxShadow: 3, overflow: 'hidden', p: 2 }}>
        <List>
          {mainCats.map((mainCat) => {
            const subCats = filteredCategories.filter(
              cat => cat.parentCategory === mainCat.categoryName
            );
            const isExpanded = expandedCategories[mainCat.categoryName];

            return (
              <Box key={mainCat.id}>
                <ListItem
                  sx={{
                    backgroundColor: 'rgba(83, 109, 254, 0.05)',
                    borderRadius: 1,
                    mb: 1,
                    '&:hover': { backgroundColor: 'rgba(83, 109, 254, 0.1)' }
                  }}
                >
                  <ListItemIcon>
                    <IconButton
                      size="small"
                      onClick={() => handleToggleExpand(mainCat.categoryName)}
                      disabled={subCats.length === 0}
                    >
                      {subCats.length > 0 ? (
                        isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />
                      ) : (
                        <FolderClosedIcon />
                      )}
                    </IconButton>
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Typography variant="h6" fontWeight="bold">
                          {mainCat.categoryName}
                        </Typography>
                        <Chip
                          label={`${mainCat.productCount} products`}
                          size="small"
                          color="primary"
                        />
                        <Chip
                          label={mainCat.status}
                          size="small"
                          sx={{ ...getStatusStyle(mainCat.status) }}
                        />
                      </Box>
                    }
                    secondary={mainCat.description}
                  />
                  <Box sx={{ display: 'flex', gap: 1 }}>
                    <Tooltip title="View Details">
                      <IconButton
                        size="small"
                        onClick={() => handleView(mainCat)}
                        sx={{ color: 'info.main' }}
                      >
                        <ViewIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Edit Category">
                      <IconButton
                        size="small"
                        onClick={() => handleEdit(mainCat)}
                        sx={{ color: 'warning.main' }}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete Category">
                      <IconButton
                        size="small"
                        onClick={() => handleDelete(mainCat.id)}
                        sx={{ color: 'error.main' }}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </ListItem>

                {/* Subcategories */}
                <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    {subCats.map((subCat) => (
                      <ListItem
                        key={subCat.id}
                        sx={{
                          pl: 8,
                          backgroundColor: 'rgba(144, 19, 254, 0.03)',
                          borderRadius: 1,
                          mb: 0.5,
                          '&:hover': { backgroundColor: 'rgba(144, 19, 254, 0.08)' }
                        }}
                      >
                        <ListItemIcon>
                          <SubCategoryIcon />
                        </ListItemIcon>
                        <ListItemText
                          primary={
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                              <Typography variant="body1" fontWeight="500">
                                {subCat.categoryName}
                              </Typography>
                              <Chip
                                label={`${subCat.productCount} products`}
                                size="small"
                                color="secondary"
                                variant="outlined"
                              />
                              <Chip
                                label={subCat.status}
                                size="small"
                                sx={{ ...getStatusStyle(subCat.status) }}
                              />
                            </Box>
                          }
                          secondary={subCat.description}
                        />
                        <Box sx={{ display: 'flex', gap: 1 }}>
                          <Tooltip title="View Details">
                            <IconButton
                              size="small"
                              onClick={() => handleView(subCat)}
                              sx={{ color: 'info.main' }}
                            >
                              <ViewIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Edit Category">
                            <IconButton
                              size="small"
                              onClick={() => handleEdit(subCat)}
                              sx={{ color: 'warning.main' }}
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Delete Category">
                            <IconButton
                              size="small"
                              onClick={() => handleDelete(subCat.id)}
                              sx={{ color: 'error.main' }}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </ListItem>
                    ))}
                  </List>
                </Collapse>
              </Box>
            );
          })}
        </List>
      </Paper>
    );
  };

  return (
    <Box sx={{ p: 3 }}>
      {/* Header Section */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Badge badgeContent={totalCategories} color="primary">
            <CategoryIcon sx={{ color: 'primary.main', fontSize: 40 }} />
          </Badge>
          <Box>
            <Typography variant="h4" fontWeight="bold" color="primary">
              Category Master Management
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Manage product categories and hierarchies • {filteredCategories.length} categories found
            </Typography>
          </Box>
        </Box>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button
            variant={viewMode === "table" ? "contained" : "outlined"}
            startIcon={<AppsIcon />}
            onClick={() => setViewMode("table")}
            sx={{
              borderRadius: 2,
              px: 2,
              py: 1,
            }}
          >
            Table View
          </Button>
          <Button
            variant={viewMode === "tree" ? "contained" : "outlined"}
            startIcon={<TreeIcon />}
            onClick={() => setViewMode("tree")}
            sx={{
              borderRadius: 2,
              px: 2,
              py: 1,
            }}
          >
            Tree View
          </Button>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleOpenModal}
            sx={{
              borderRadius: 2,
              px: 3,
              py: 1,
              fontWeight: 600,
              backgroundColor: 'primary.main',
              '&:hover': {
                backgroundColor: 'primary.dark',
              },
            }}
          >
            Add New Category
          </Button>
        </Box>
      </Box>

      {/* Success Message */}
      {successMessage && (
        <Alert severity="success" sx={{ mb: 2, borderRadius: 2 }}>
          {successMessage}
        </Alert>
      )}

      {/* Statistics Cards */}
      {/* <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6} md={2.4}>
          <Card sx={{ borderRadius: 2, boxShadow: 2 }}>
            <CardContent sx={{ textAlign: 'center' }}>
              <CategoryIcon sx={{ fontSize: 40, color: 'primary.main', mb: 1 }} />
              <Typography variant="h6" fontWeight="bold" color="primary">
                {totalCategories}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Total Categories
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={2.4}>
          <Card sx={{ borderRadius: 2, boxShadow: 2 }}>
            <CardContent sx={{ textAlign: 'center' }}>
              <FolderIcon sx={{ fontSize: 40, color: 'success.main', mb: 1 }} />
              <Typography variant="h6" fontWeight="bold" color="success.main">
                {mainCategoriesCount}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Main Categories
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={2.4}>
          <Card sx={{ borderRadius: 2, boxShadow: 2 }}>
            <CardContent sx={{ textAlign: 'center' }}>
              <SubCategoryIcon sx={{ fontSize: 40, color: 'secondary.main', mb: 1 }} />
              <Typography variant="h6" fontWeight="bold" color="secondary.main">
                {subCategoriesCount}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Sub Categories
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={2.4}>
          <Card sx={{ borderRadius: 2, boxShadow: 2 }}>
            <CardContent sx={{ textAlign: 'center' }}>
              <CheckCircleIcon sx={{ fontSize: 40, color: 'info.main', mb: 1 }} />
              <Typography variant="h6" fontWeight="bold" color="info.main">
                {activeCategories}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Active Categories
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={2.4}>
          <Card sx={{ borderRadius: 2, boxShadow: 2 }}>
            <CardContent sx={{ textAlign: 'center' }}>
              <TagIcon sx={{ fontSize: 40, color: 'warning.main', mb: 1 }} />
              <Typography variant="h6" fontWeight="bold" color="warning.main">
                {totalProducts}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Total Products
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid> */}

      {/* Search and Filter Section */}
      <Paper sx={{ p: 3, mb: 3, borderRadius: 2, boxShadow: 2 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Search Categories..."
              variant="outlined"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} md={2.5}>
            <TextField
              select
              fullWidth
              label="Filter by Level"
              value={levelFilter}
              onChange={(e) => setLevelFilter(e.target.value)}
              SelectProps={{
                native: true,
              }}
            >
              <option value="all">All Levels</option>
              <option value="Main Category">Main Category</option>
              <option value="Sub Category">Sub Category</option>
            </TextField>
          </Grid>
          <Grid item xs={12} md={2.5}>
            <TextField
              select
              fullWidth
              label="Filter by Status"
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              SelectProps={{
                native: true,
              }}
            >
              <option value="all">All Status</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </TextField>
          </Grid>
          <Grid item xs={12} md={3}>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Button
                variant="contained"
                onClick={handleSearch}
                startIcon={<SearchIcon />}
                sx={{ flex: 1 }}
              >
                Search
              </Button>
              <Button
                variant="outlined"
                onClick={handleReset}
                startIcon={<RefreshIcon />}
                sx={{ flex: 1 }}
              >
                Reset
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Paper>

      {/* Table or Tree View */}
      {viewMode === "tree" ? (
        renderTreeView()
      ) : (
        <Paper sx={{ borderRadius: 2, boxShadow: 3, overflow: 'hidden' }}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: '#f8f9fa' }}>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>S.No</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Category Code</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Category Name</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Parent Category</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Level</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Products</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Display Order</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Show on Web</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Status</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }} align="center">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredCategories.length > 0 ? (
                  filteredCategories
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((category, index) => (
                      <TableRow
                        key={category.id}
                        sx={{
                          '&:hover': { backgroundColor: '#f5f5f5' },
                          transition: 'background-color 0.2s'
                        }}
                      >
                        <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                        <TableCell>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <TagIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
                            {category.categoryCode}
                          </Box>
                        </TableCell>
                        <TableCell sx={{ fontWeight: 500 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            {category.level === "Main Category" ? (
                              <FolderIcon sx={{ color: 'primary.main' }} />
                            ) : (
                              <SubCategoryIcon sx={{ color: 'secondary.main' }} />
                            )}
                            {category.categoryName}
                          </Box>
                        </TableCell>
                        <TableCell>{category.parentCategory || '-'}</TableCell>
                        <TableCell>
                          <Chip
                            label={category.level}
                            size="small"
                            color={getLevelColor(category.level)}
                            sx={{ fontWeight: 500 }}
                          />
                        </TableCell>
                        <TableCell>
                          <Typography
                            sx={{
                              fontWeight: 600,
                              color: category.productCount === 0 ? 'text.secondary' : 'primary.main'
                            }}
                          >
                            {category.productCount}
                          </Typography>
                        </TableCell>
                        <TableCell>{category.displayOrder}</TableCell>
                        <TableCell>
                          {category.showOnWebsite ? (
                            <CheckCircleIcon sx={{ color: 'success.main' }} />
                          ) : (
                            <CancelIcon sx={{ color: 'error.main' }} />
                          )}
                        </TableCell>
                        <TableCell>
                          <Chip
                            label={category.status}
                            size="small"
                            sx={{
                              ...getStatusStyle(category.status),
                              fontWeight: 600,
                              fontSize: '0.75rem'
                            }}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                            <Tooltip title="View Details">
                              <IconButton
                                size="small"
                                onClick={() => handleView(category)}
                                sx={{
                                  color: 'info.main',
                                  '&:hover': {
                                    backgroundColor: 'info.light',
                                    transform: 'scale(1.1)',
                                  },
                                  transition: 'all 0.2s'
                                }}
                              >
                                <ViewIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Edit Category">
                              <IconButton
                                size="small"
                                onClick={() => handleEdit(category)}
                                sx={{
                                  color: 'warning.main',
                                  '&:hover': {
                                    backgroundColor: 'warning.light',
                                    transform: 'scale(1.1)',
                                  },
                                  transition: 'all 0.2s'
                                }}
                              >
                                <EditIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Delete Category">
                              <IconButton
                                size="small"
                                onClick={() => handleDelete(category.id)}
                                sx={{
                                  color: 'error.main',
                                  '&:hover': {
                                    backgroundColor: 'error.light',
                                    transform: 'scale(1.1)',
                                  },
                                  transition: 'all 0.2s'
                                }}
                              >
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={10} align="center" sx={{ py: 4 }}>
                      <CategoryIcon sx={{ fontSize: 48, color: 'text.disabled', mb: 1 }} />
                      <Typography variant="body1" color="text.secondary">
                        No categories found
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Try adjusting your search criteria or add a new category.
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            component="div"
            count={filteredCategories.length}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[5, 10, 25, 50]}
          />
        </Paper>
      )}

      {/* Add/Edit Category Modal */}
      <Dialog open={openModal} onClose={handleCloseModal} maxWidth="md" fullWidth>
        <DialogTitle sx={{
          backgroundColor: 'primary.main',
          color: 'white',
          padding: '16px 24px',
        }}>
          <Typography variant="h6" component="div" sx={{ color: 'white', display: 'flex', alignItems: 'center', gap: 1 }}>
            <CategoryIcon />
            {editingCategory ? 'Edit Category' : 'Add New Category'}
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ padding: '24px', mt: 2 }}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Category Code"
                name="categoryCode"
                value={newCategory.categoryCode}
                onChange={handleInputChange}
                error={!!errors.categoryCode}
                helperText={errors.categoryCode || "Auto-generated if left empty"}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <TagIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Category Name"
                name="categoryName"
                value={newCategory.categoryName}
                onChange={handleInputChange}
                error={!!errors.categoryName}
                helperText={errors.categoryName}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Category Level *</InputLabel>
                <Select
                  name="level"
                  value={newCategory.level}
                  onChange={handleInputChange}
                  label="Category Level *"
                >
                  <MenuItem value="Main Category">Main Category</MenuItem>
                  <MenuItem value="Sub Category">Sub Category</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth error={!!errors.parentCategory}>
                <InputLabel>Parent Category</InputLabel>
                <Select
                  name="parentCategory"
                  value={newCategory.parentCategory}
                  onChange={handleInputChange}
                  label="Parent Category"
                  disabled={newCategory.level === "Main Category"}
                >
                  <MenuItem value="">None</MenuItem>
                  {mainCategories.map((cat) => (
                    <MenuItem key={cat.id} value={cat.categoryName}>
                      {cat.categoryName}
                    </MenuItem>
                  ))}
                </Select>
                {errors.parentCategory && (
                  <Typography variant="caption" color="error" sx={{ ml: 2 }}>
                    {errors.parentCategory}
                  </Typography>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Display Order"
                name="displayOrder"
                type="number"
                value={newCategory.displayOrder}
                onChange={handleInputChange}
                error={!!errors.displayOrder}
                helperText={errors.displayOrder || "Order in which category appears"}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Status</InputLabel>
                <Select
                  name="status"
                  value={newCategory.status}
                  onChange={handleInputChange}
                  label="Status"
                >
                  <MenuItem value="Active">Active</MenuItem>
                  <MenuItem value="Inactive">Inactive</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={newCategory.showOnWebsite}
                    onChange={handleInputChange}
                    name="showOnWebsite"
                    color="primary"
                  />
                }
                label="Show on Website"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Description"
                name="description"
                value={newCategory.description}
                onChange={handleInputChange}
                multiline
                rows={3}
                placeholder="Enter category description..."
              />
            </Grid>
          </Grid>
          {errors.general && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {errors.general}
            </Alert>
          )}
        </DialogContent>
        <DialogActions sx={{ padding: '16px 24px' }}>
          <Button onClick={handleCloseModal} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleAddCategory}
            disabled={isLoading}
            startIcon={isLoading ? <CircularProgress size={20} /> : <AddIcon />}
            sx={{
              backgroundColor: 'primary.main',
              '&:hover': {
                backgroundColor: 'primary.dark',
              },
            }}
          >
            {isLoading ? 'Processing...' : (editingCategory ? 'Update Category' : 'Add Category')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* View Category Modal */}
      <Dialog open={openViewModal} onClose={handleCloseViewModal} maxWidth="md" fullWidth>
        <DialogTitle sx={{
          backgroundColor: 'primary.main',
          color: 'white',
          padding: '16px 24px',
        }}>
          <Typography variant="h6" component="div" sx={{ color: 'white', display: 'flex', alignItems: 'center', gap: 1 }}>
            <InfoIcon />
            Category Details
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ padding: '24px', mt: 2 }}>
          {viewingCategory && (
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Box sx={{ textAlign: 'center', mb: 3 }}>
                  <Avatar
                    sx={{
                      width: 80,
                      height: 80,
                      margin: '0 auto',
                      backgroundColor: 'primary.main',
                    }}
                  >
                    {viewingCategory.level === "Main Category" ? (
                      <FolderIcon sx={{ fontSize: 40 }} />
                    ) : (
                      <SubCategoryIcon sx={{ fontSize: 40 }} />
                    )}
                  </Avatar>
                  <Typography variant="h5" sx={{ mt: 2, fontWeight: 'bold' }}>
                    {viewingCategory.categoryName}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {viewingCategory.categoryCode}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Category Level</Typography>
                  <Box sx={{ mt: 1 }}>
                    <Chip
                      label={viewingCategory.level}
                      color={getLevelColor(viewingCategory.level)}
                    />
                  </Box>
                </Paper>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Parent Category</Typography>
                  <Typography variant="body1" fontWeight="bold">
                    {viewingCategory.parentCategory || 'None (Main Category)'}
                  </Typography>
                </Paper>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Total Products</Typography>
                  <Typography variant="body1" fontWeight="bold" color="primary">
                    {viewingCategory.productCount} Products
                  </Typography>
                </Paper>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Display Order</Typography>
                  <Typography variant="body1" fontWeight="bold">
                    {viewingCategory.displayOrder}
                  </Typography>
                </Paper>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Status</Typography>
                  <Box sx={{ mt: 1 }}>
                    <Chip
                      label={viewingCategory.status}
                      sx={{
                        ...getStatusStyle(viewingCategory.status),
                        fontWeight: 600,
                      }}
                    />
                  </Box>
                </Paper>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Show on Website</Typography>
                  <Box sx={{ mt: 1 }}>
                    {viewingCategory.showOnWebsite ? (
                      <Chip icon={<CheckCircleIcon />} label="Visible" color="success" />
                    ) : (
                      <Chip icon={<CancelIcon />} label="Hidden" color="error" />
                    )}
                  </Box>
                </Paper>
              </Grid>

              <Grid item xs={12}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Description</Typography>
                  <Typography variant="body1" sx={{ mt: 1 }}>
                    {viewingCategory.description || 'No description available'}
                  </Typography>
                </Paper>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(144, 19, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Created Date</Typography>
                  <Typography variant="body1" fontWeight="bold">
                    {viewingCategory.createdDate}
                  </Typography>
                </Paper>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(144, 19, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Last Updated</Typography>
                  <Typography variant="body1" fontWeight="bold">
                    {viewingCategory.updatedDate}
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions sx={{ padding: '16px 24px' }}>
          <Button onClick={handleCloseViewModal}>Close</Button>
          {viewingCategory && (
            <Button
              variant="contained"
              onClick={() => {
                handleCloseViewModal();
                handleEdit(viewingCategory);
              }}
              startIcon={<EditIcon />}
              sx={{
                backgroundColor: 'primary.main',
                '&:hover': {
                  backgroundColor: 'primary.dark',
                },
              }}
            >
              Edit Category
            </Button>
          )}
        </DialogActions>
      </Dialog>

      <AlertModal
        open={alertConfig.open}
        title={alertConfig.title}
        message={alertConfig.message}
        type={alertConfig.type}
        onClose={() => setAlertConfig({ ...alertConfig, open: false })}
      />

      <ConfirmModal
        open={confirmConfig.open}
        title={confirmConfig.title}
        onClose={() => setConfirmConfig({ ...confirmConfig, open: false })}
        onConfirm={() => {
          if (confirmConfig.onConfirm) confirmConfig.onConfirm();
          setConfirmConfig({ ...confirmConfig, open: false });
        }}
        type="warning"
      >
        {confirmConfig.message}
      </ConfirmModal>

    </Box>
  );
};

export default CategoryMaster;

